import { Injectable } from '@angular/core';
import { ApiService, IApiOption } from '@red/api';
import { PaginationAdapter } from '@red/data-access';
import { AuditTrailModel } from '@shared/data-access/models';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuditTrailApiService {
  static ROOT_POINT = 'settings/audit-trail';
  static ROOT_POINT_HRM = 'settings/audit-trail/hrm';
  static ROOT_POINT_TRANSACTION = 'settings/audit-trail/transaction';
  static ROOT_POINT_FINANCE = 'settings/audit-trail/finance';
  static ROOT_POINT_CONFIGURATION = 'settings/audit-trail/configuration';
  static ROOT_POINT_DCDD = 'settings/audit-trail/dcdd';

  constructor(private apiService: ApiService) { }

  getHrm(itemId: number): Observable<AuditTrailModel> {
    return this.apiService.get(AuditTrailApiService.ROOT_POINT_HRM + '/' + itemId).pipe(map(res => AuditTrailModel.fromJson(res) as AuditTrailModel));
  }
  getTransaction(itemId: number): Observable<AuditTrailModel> {
    return this.apiService.get(AuditTrailApiService.ROOT_POINT_TRANSACTION + '/' + itemId).pipe(map(res => AuditTrailModel.fromJson(res) as AuditTrailModel));
  }
  getFinance(itemId: number): Observable<AuditTrailModel> {
    return this.apiService.get(AuditTrailApiService.ROOT_POINT_FINANCE + '/' + itemId).pipe(map(res => AuditTrailModel.fromJson(res) as AuditTrailModel));
  }
  getConfiguration(itemId: number): Observable<AuditTrailModel> {
    return this.apiService.get(AuditTrailApiService.ROOT_POINT_CONFIGURATION + '/' + itemId).pipe(map(res => AuditTrailModel.fromJson(res) as AuditTrailModel));
  }

  searchHrm(query = {}, option?: IApiOption): Observable<PaginationAdapter<AuditTrailModel>> {
    return this.apiService.get(AuditTrailApiService.ROOT_POINT_HRM, query, option).pipe(map(data => new PaginationAdapter(AuditTrailModel, data)));
  }
  searchTransaction(query = {}, option?: IApiOption): Observable<PaginationAdapter<AuditTrailModel>> {
    return this.apiService.get(AuditTrailApiService.ROOT_POINT_TRANSACTION, query, option).pipe(map(data => new PaginationAdapter(AuditTrailModel, data)));
  }
  searchFinance(query = {}, option?: IApiOption): Observable<PaginationAdapter<AuditTrailModel>> {
    return this.apiService.get(AuditTrailApiService.ROOT_POINT_FINANCE, query, option).pipe(map(data => new PaginationAdapter(AuditTrailModel, data)));
  }
  searchConfiguration(query = {}, option?: IApiOption): Observable<PaginationAdapter<AuditTrailModel>> {
    return this.apiService.get(AuditTrailApiService.ROOT_POINT_CONFIGURATION, query, option).pipe(map(data => new PaginationAdapter(AuditTrailModel, data)));
  }
  searchDcdd(query = {}, option?: IApiOption): Observable<PaginationAdapter<AuditTrailModel>> {
    return this.apiService.get(AuditTrailApiService.ROOT_POINT_DCDD, query, option).pipe(map(data => new PaginationAdapter(AuditTrailModel, data)));
  }

  delete(id: number, option?: IApiOption): Observable<any> {
    return this.apiService.delete(AuditTrailApiService.ROOT_POINT + '/' + id, option);
  }

}
